module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?3e81ae3d5da947449b00c686bfe100af";